import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import Unit from './unit';
import Block from './block';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 48px 0 92px;
  .wrapper {
    .list,
    .products {
      display: flex;
      flex-wrap: wrap;
    }
    .products {
      margin-bottom: 70px;
    }
    button.load {
      margin: 40px auto 0;
      cursor: pointer;
      max-width: 260px;
      width: 100%;
      background: #F1A857;
      display: flex;
      border-radius: 3px;
      border: 0;
      color: #fff;
      height: 60px;
      align-items: center;
      font-size: 16px;
      padding: 0;
      @media (max-width: 1080px) {
        margin: 0 auto;
      }
      span {
        height: 100%;
        flex-grow: 1;
        border-right: 1px solid #D99440;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i {
        width: 50px;
        background: url(/images/arrow-right.png) center no-repeat;
        height: 100%;
      }
    }
  }
`
const Title = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 30px;
  strong {
    font: bold italic 34px/30px 'Times new roman';
  }
  span {
    font-size: 16px;
    color: #40403F;
    margin-left: 15px;
  }
`

const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
const Client = Prismic.client(apiEndpoint);

class Search extends Component {
  state = {
    term: '',
    categoria: [],
    blog: [],
    total_blog: 0,
    total_produto: 0,
    produtos: [],
    language: ''
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    const { language } = this.context;
    const fetchDataCategoria = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'categoria_produtos')
      )
      if (response) {
        this.setState({categoria: response.results, language: language});
      }
    }
    fetchDataCategoria();

    this.setSearch(this.props.match.params.search)
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      (this.props.match.params.search !== this.state.term) ||
      (this.state.language !== language)
    ) {
      this.setState({language: language});
      this.setSearch(this.props.match.params.search);
    }
  }

  setSearch = (value) => {
    const { language } = this.context;
    this.setState({'term': value, blog: [], total_blog: 0, total_produto: 0, produtos: []});
    const fetchDataBlog = async () => {
      Client.query([
          Prismic.Predicates.at('document.type', 'conteudo'),
          Prismic.Predicates.fulltext('document', value)
        ],
        {lang: language}
      ).then(response => {
        this.setState({total_blog: response.total_results_size, blog: response.results});
      })
    }
    fetchDataBlog();
    const fetchDataProdutos = async () => {
      Client.query([
          Prismic.Predicates.at('document.type', 'produto'),
          Prismic.Predicates.fulltext('document', value)
        ],
        {lang: language}
      ).then(response => {
        response.results.map((item) => {
          item.category = this.state.categoria.filter((categoria) => categoria.id === item.data.categoria_produto.id)[0]
          return false;
        })
        this.setState({total_produto: response.total_results_size, produtos: response.results});
      })
    }
    fetchDataProdutos();
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let busca = ''
    let buscandoPor = ''
    let produtos = ''
    let produtosText = ''
    let conteudos = ''
    let conteudosText = ''
    switch (language) {
      case 'pt-br':
        busca = 'Busca'
        home = 'Início'
        buscandoPor = 'Buscando por'
        produtos = 'Produtos'
        produtosText = 'produtos encontrados'
        conteudos = 'Conteúdos'
        conteudosText = 'conteúdos encontrado'
        break;
      case 'en-us':
        busca = 'Search'
        home = 'Home'
        buscandoPor = 'Searching for'
        produtos = 'Products'
        produtosText = 'found products'
        conteudos = 'Content'
        conteudosText = 'found content'
        break;
      case 'es-es':
        busca = 'Busqueda'
        home = 'Inicio'
        buscandoPor = 'Buscando'
        produtos = 'Productos'
        produtosText = 'productos encontrados'
        conteudos = 'Contenido'
        conteudosText = 'contenidos encontrados'
        break;
      default:
    }
    return (
      <div id="home">
        <Header />
        <Breadcrumbs title={ `${buscandoPor}: ${this.state.term}` } link="/">
          <div>
            <Link to="/">{ home }</Link>
            <span>{ busca }</span>
          </div>
        </Breadcrumbs>
        <Container>
          <div className="wrapper">
            <Title>
              <strong>{ produtos }</strong>
              <span>{ this.state.total_produto } {produtosText}</span>
            </Title>
            <div className="products">
              {
                this.state.produtos && this.state.produtos.map((item, index) => {
                  return item && (
                    <Unit {...item.data} category={ item.category && item.category.data } uid={ item.uid } key={ index } />
                  )
                })
              }
            </div>
            <Title>
              <strong>{ conteudos }</strong>
              <span>{ this.state.total_blog } { conteudosText }</span>
            </Title>
            <div className="list">
              {
                this.state.blog.map((item, index) => {
                  return (
                    <Block 
                      key={ index }
                      {...item.data}
                      uid={ item.uid } />
                  )
                })
              }
            </div>
          </div>
        </Container>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

Search.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Search.contextType = LanguageContext;

export default Search;
